import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import { Paginator } from "primereact/paginator";
import { getCrewDetails, getPhoto } from "../Actions/CrewManagement";
import logo from "../Asset/download.jpg";
import Modal from "react-bootstrap/Modal";
import Role from "../helpers/role";
import "../App.css";

let userRole = localStorage.getItem("UserRoles");

class CrewManagementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      Name: "",
    };
  }

  render() {
    const { pageSize, totalRecords, GetPhoto, arraylist } = this.props;

    return (
      <div className="" style={{ paddingTop: "12px" }}>
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {this.state.Name}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <img
                src={GetPhoto ? GetPhoto : logo}
                alt="Smiley face"
                // style={{ width: "100%" }}
                width="100%"
                class=""
              ></img>
            </div>
          </Modal.Body>
        </Modal>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              className="mb-3"
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <OverlayTrigger
              placement="right-start"
              delay={{ show: 250, hide: 400 }}
              overlay={this.renderPopover(
                item?.mappedDevices,
                item?.pendingDevices,
                item?.isDeletedInPortal
              )}
            >
              {item?.isDeletedInPortal === true ? (
                <div className="arrow-left-yellow"></div>
              ) : item?.isAddedInDevice === true ? (
                <div className="arrow-left-green"></div>
              ) : (
                <div className="arrow-left-red"></div>
              )}
            </OverlayTrigger>
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      !showSidePane
                        ? "col-md-2 col-sm-2 col-lg-1 col-2 ml-3"
                        : "col-md-2 col-sm-2 col-lg-1 col-2 ml-3"
                    }
                  >
                    <div className="text-center rounded-circle m-2">
                      <a onClick={() => this.getPhotoView(item)}>
                        <img
                          src={item.photo ? item.photo : logo}
                          alt="Smiley face"
                          height="85"
                          width="85"
                          // style={{ width: "90%" }}
                          class="rounded-circle"
                        ></img>
                      </a>
                    </div>
                  </div>
                  <div
                    className={
                      !showSidePane
                        ? "col-md-7 col-sm-7  col-lg-7 col-7 col-m-auto m1-3"
                        : "col-md-7 col-sm-7  col-lg-7 col-7 col-m-auto ml-3 mr-0"}>
                    <div className="row pl-5">
                      <div
                        className={
                          showSidePane
                            ? "col-sm-6 mb-1"
                            : "col-sm-4 col-md-4 pb-2"
                        }
                      >
                        <span>
                          <strong>Crew ID : </strong>
                          <span className="italicFont">{item.crewId} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-sm-6 mb-1"
                            : "col-sm-4 col-md-4 pb-2"
                        }
                      >
                        <span>
                          <strong>Name : </strong>
                          <span className="italicFont ">{item.name} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-sm-6 mb-1"
                            : "col-sm-4 col-md-4 pb-2"
                        }
                      >
                        <span>
                          <strong>Rank : </strong>
                          <span className="italicFont ">
                            {item.designation}{" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-sm-12 mb-1"
                            : "col-sm-12 col-md-12 pb-2"
                        }
                      >
                        <span>
                          <strong>Ship Name : </strong>
                          <span className="italicFont">{item.shipName} </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      !showSidePane
                        ? "col-md-2 col-sm-2 col-lg-2 col-2 d-flex justify-content-end align-items-center mr-2"
                        : "col-md-2 col-sm-2 col-lg-2 col-2 d-flex justify-content-end align-items-center mr-2"}>
                    <div
                      className={!showSidePane ? ` ${item.isDeletedInPortal ? "eyeiconstyle" : ""}`
                        : `m10 ${item.isDeletedInPortal ? "eyeiconstyle" : ""}`} >
                      {item.syncIssue ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderMessageover}
                        >
                          <i
                            className="fa fa-exclamation-triangle p-1"
                            aria-hidden="true"
                            style={{ color: "#d41616f5", fontSize: "1.8rem" }}
                          ></i>
                        </OverlayTrigger>
                      ) : null}
                      <i
                        className="fa fa-eye fa-2x click p-1"
                        aria-hidden="true"
                        onClick={() => this.eyeclick(item.crewMemberId)}
                        style={{
                          color: `${item.isDeletedInPortal ? "grey" : "#1a3464"
                            }`,
                          // fontSize: "1.8rem",
                        }}
                      ></i>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };

  eyeclick = (id) => {
    if (userRole == Role.staff) {
      this.props.dispatch({ type: "CrewDetails", data: true });
      this.props.dispatch({ type: "ClearSearchValues", data: false });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.dispatch(getCrewDetails(id));
      this.props.history.push(`/Home/CrewManagement/${id}`);
      window.scrollTo(0, 0);
    } else {
      this.props.dispatch({ type: "CrewDetails", data: true });
      this.props.dispatch({ type: "ClearSearchValues", data: false });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.dispatch(getCrewDetails(id));
      this.props.history.push(`/Home/Management/CrewManagement/${id}`);
      window.scrollTo(0, 0);
    }
  };

  getPhotoView = (item) => {
    this.props.dispatch({ type: "getPhotoSuccess", data: "" });
    this.state.Name = item.name;
    this.setState({ modalIsOpen: true });
    this.props.dispatch(getPhoto(item.crewMemberId));
  };

  renderMessageover(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label>Failed to sync with device.</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderPopover(mappedDevices, pendingDevices, isDeletedInPortal) {
    return (
      <Popovers id="history-tooltip">
        <Popovers.Content>
          {isDeletedInPortal ? (
            <>
              <label style={{ padding: "0px 10px" }}>
                <span style={{ fontWeight: "bolder" }}>
                  User deleted awaiting to sync with device :{" "}
                </span>
                {pendingDevices === null || pendingDevices?.length === 0
                  ? mappedDevices === null || mappedDevices.length === 0
                    ? ""
                    : mappedDevices.length > 1
                      ? mappedDevices.reduce(function (a, b) {
                        return (a || a) + ", " + b;
                      })
                      : mappedDevices.map((i) => i.toString())
                  : pendingDevices.length > 1
                    ? pendingDevices.reduce(function (a, b) {
                      return (a || a) + ", " + b;
                    })
                    : pendingDevices.map((i) => i.toString())}
              </label>
            </>
          ) : (
            <>
              <label
                style={{
                  padding: "0px 10px",
                  display:
                    pendingDevices === null || pendingDevices.length === 0
                      ? "none"
                      : "block",
                }}
              >
                <span
                  style={{
                    fontWeight: "bolder",
                    display:
                      pendingDevices === null || pendingDevices.length === 0
                        ? "none"
                        : "block",
                  }}
                >
                  Pending Devices :{" "}
                </span>
                {pendingDevices === null
                  ? " "
                  : pendingDevices.length === 0
                    ? " "
                    : pendingDevices.length > 1
                      ? pendingDevices.reduce(function (a, b) {
                        return (a || a) + ", " + b;
                      })
                      : pendingDevices.map((i) => i.toString())}
              </label>
              <label style={{ padding: "0px 10px" }}>
                <span style={{ fontWeight: "bolder" }}>Mapped Devices : </span>
                {mappedDevices === null
                  ? " "
                  : mappedDevices.length === 0
                    ? ""
                    : mappedDevices.length > 1
                      ? mappedDevices.reduce(function (a, b) {
                        return (a || a) + ", " + b;
                      })
                      : mappedDevices.map((i) => i.toString())}
              </label>
            </>
          )}
        </Popovers.Content>
      </Popovers>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    GetPhoto: state.CrewManagementReducer.GetPhoto || "",
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CrewManagementCard)
);
